import sensors from 'sa-sdk-javascript';

sensors.init({ // 神策系统配置
    server_url: 'https://sc8106.ssish.com/sa?project=' + (window.location.href.indexOf('nyboss') > -1  ? 'production' : 'default'),
    is_track_single_page: true, // 单页应用页面浏览事件采集(url改变就触发)
    use_app_track: true,
    show_log: true,
    heatmap: { // 热图设置 default开启 not_collect关闭（详细配置解释看官方文档）
      clickmap: 'default', // 点击热图，收集点击事件
      scroll_notice_map: 'default', // 视区热图，收集页面区域停留时间
      collect_tags: {
            div: {
                ignore_tags: ['span', 'mark', 'strong', 'b', 'em', 'i', 'u', 'abbr', 'ins', 'del', 's', 'sup']
            }
        }
    }
})
sensors.quick('autoTrack') // 首次触发页面加载事件 $pageview
function getSensorsUrlPath(){
	var url = document.location.toString();
	var arrUrl = url.split("//");
	var start = arrUrl[1].indexOf("/");
	var relUrl = arrUrl[1].substring(start);
	if(relUrl.indexOf("?") != -1){
		relUrl = relUrl.split("?")[0];
	}
	return relUrl;
}
function getUrlParams(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
	var r = window.location.search.substr(1).match(reg);  //匹配目标参数
	if (r != null) return unescape(r[2]); return null; //返回参数值
}

export default function sensorsEvent(params) {
    if (!sensors) {return;}
    let href = window.location.href;
    console.log(href)
    let bindEventName = '';
    if (href.indexOf('/productDetail') > -1) { // 产品详情页埋点
        bindEventName = 'insure_product_detail';
    } else if (href.indexOf('/productAppointmentSuccess') > -1) { // 投保信息确认页埋点
        bindEventName = 'insure_info_confirm';
    } else if (href.indexOf('/productAppointment') > -1) { // 投保信息填写页埋点
        bindEventName = 'insure_info_collect';
    }
    if(params.distinct_id) {
        login(params.distinct_id)
    }
    sensors.track(bindEventName, {
        $url: window.location.href,
        $url_path: getSensorsUrlPath(),
        $referrer: document.referrer,
        $title: document.title,
        host: document.domain,
        platform_name:'offline_appointment',
        wechatlink_product_code: params.producCode, // 产品code
        wechatlink_user_id: params.userId, // 用户id
        wechatlink_login_name: params.loginName, // 用户名
        wechatlink_share_from: getUrlParams('from'),
        wechatlink_customer_name: params.customerName, // 客户姓名
        wechatlink_corporation_Name: params.corporationName, // 保险公司
        nymanager: params.nymanager, // 用户所属客户经理
        channel_system: params.channelSystem || params.channelsystem, // 渠道
        main_product_code: params.mainProductCode, // 主产品code
    });
}
export function login (distinct_id) {
    sensors.login(distinct_id)
}